import React from 'react'
import { AdminRoutes } from '../../Routes/AdminRoutes'
import { Link } from 'react-router-dom'
import styles from "./AdminDash.module.css";

const AdminDash = () => {
  return (
    <div className={styles.main}>
        <div className={styles.sidebar1}>
            <div className={styles.logoDiv}><img src="/images/GS.png" width="50vh" alt="small logo"/></div>
            
            <div className={styles.sideLink}>
                <br/>
            <Link to='/admin_dashboard' className={styles.linkNav}>Dashboard</Link><br/>
            <Link to='/admin_dashboard/admin/users/show' className={styles.linkNav}>Users Show</Link><br/>
            <Link to='/admin_dashboard/admin/products/show' className={styles.linkNav}>Products Show</Link><br/>
            <Link to='/admin_dashboard/admin/products/add' className={styles.linkNav}>Products Add</Link><br/>
            <Link to='/admin_dashboard/admin/products/edit' className={styles.linkNav}>Products Edit</Link><br/>
            <Link to='/admin_dashboard/admin/createAdmin' className={styles.linkNav}>Admin</Link><br/>
            <Link to='/' className={styles.linkNav} onClick={()=>{localStorage.removeItem('token')}}>Logout</Link>
            </div>
        </div>
        <div className={styles.sidebar2}>
            <div className={styles.MainDashTop}>
                <img src="/images/gharseva.png"  width="200vh" alt="logo" />
            </div>
            <div>
                <AdminRoutes />
            </div>
        </div>
    </div>
  )
}

export default AdminDash